import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { LoaderService } from '@app/shared/services/loader.service';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { RolesSharedService } from '../../../services/roles-shared.service';
import { ServiceProvidersService } from '../../../services/service-providers.service';
import { AnalystComponent } from './analyst/analyst.component';

@Component({
  selector: 'app-analyst-search-results',
  templateUrl: './analyst-search-results.component.html',
  styleUrls: ['./analyst-search-results.component.css']
})
export class AnalystSearchResultsComponent implements OnInit {

  @ViewChild('analystComponent') public analystComponent: AnalystComponent;
  @ViewChild('searchInput') searchInput : ElementRef;
  
  @Input() searchResults: any;
  serviceProviders = [];
  isUserSignedIn: boolean;
  // userSignInSubscription$: Subscription;
  selectedSortOption: any;
  selector = 'sp-listing';
  sortByOptions: any;
  searchItems: any;
  subHeaderItem: any;
  subHeaderText: string;
  subHeaderSubItem:any={};
  currentUser: any;
  searchResultsEmpty: boolean;
  isSearchResultsLoading = false;
  filter: any = {};
  selectedAnalystList =[];

  searchString = "";
  dataLimit = 9;
  skipValue = 0;

  constructor(
    public router: Router,
    private authService: AuthenticationService,
    private serviceProvidersService: ServiceProvidersService,
    private rolesSharedService:RolesSharedService,
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
      if ( this.authService.isLoggedIn()) {
        let role = this.authService.getFormattedRole();
        if (role === 'tech-buyer' || role==='tech-vendor') {
          this.selectedSortOption = {
            name: 'Ratings: High to Low',
            id: 'sequence, rating desc'
          };
          this.sortByOptions = [
            {
              name: 'Name: A-Z',
              id: 'sequence, name asc'
            },
            {
              name: 'Name: Z-A',
              id: 'sequence, name desc'
            },
            {
              name: 'Ratings: Low to High',
              id: 'sequence, rating asc'
            },
            {
              name: 'Ratings: High to Low',
              id: 'sequence, rating desc'
            }
          ];
        } 
      } else {
        this.sortByOptions = [
          {
            name: 'Name: A-Z',
            id: 'sequence, name asc'
          },
          {
            name: 'Name: Z-A',
            id: 'sequence, name desc'
          }
        ];
      }
    this.serviceProvidersService.searchItemObservable.subscribe(
      resp => {
        this.searchItems = resp;
      }
    );
    // this.searchResultsEmpty = Object.entries(this.searchResults).length === 0;

    // this.serviceProvidersService.serviceProvider.subscribe(
    //   resp => {
    //     this.isSearchResultsLoading = false;
    //     if (resp) {
    //       this.searchResults = resp;
    //       this.isSearchResultsLoading = true;
    //       this.searchResultsEmpty = Object.entries(this.searchResults).length === 0;
    //     }
    //   }
    // );

    this.filter.search = "";
    let searchKey = "";
    this.rolesSharedService.getNewAnalystListDetails(this.filter).subscribe((data: any) => {
      this.searchResults = data;
      for (let index = 0; index < this.searchResults.length; index++) {
        Object.assign(this.searchResults[index], { isSelected: false });
      }
    });
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      // Time in milliseconds between key events
      ,debounceTime(1000)        
      // If previous query is diffent from current   
      ,distinctUntilChanged()
      // subscription for response
      ).subscribe((text: string) => {
        this.searchString = text;
        this.searchResults = [];
        this.dataLimit = 9;
        this.skipValue = 0;
        this.getAnalystList();
      });
  }

  getAnalystList() {
    let searchKey = this.searchString;
    const filter: any = {};
    filter.search = this.searchString;
    this.rolesSharedService.getNewAnalystListDetails(filter).subscribe((data: any) => {
      if (searchKey === this.searchString) {
      this.searchResults = data;
      this.loaderService.display(false);
      }
    });
  }

  applyFilter() {
    this.searchResults = [];
    this.dataLimit = 9;
    this.skipValue = 0;
    this.getAnalystList();
  }

  onSortOptionClicked() {
    this.searchItems.offset = 0;
    this.searchItems.orderBy = this.selectedSortOption.id;
    if (this.searchItems.orderBy == 'sequence, name asc') {
      this.searchResults.sort((a, b) => a.name > b.name ? 1 : -1)
    }
    else if (this.searchItems.orderBy == 'sequence, name desc') {
      this.searchResults.sort((a, b) => a.name > b.name ? -1 : 1)
    } else if (this.searchItems.orderBy == 'sequence, rating asc') {
      this.searchResults.sort((a, b) => a.ratings > b.ratings ? 1 : -1)
    } else {
      this.searchResults.sort((a, b) => a.ratings > b.ratings ? -1 : 1)
    }
  }

  onScroll() {
    this.searchItems.offset += this.searchItems.limit;
    if (this.searchItems.offset < this.searchResults.totalCount) {
      this.rolesSharedService.getNewAnalystListDetails(this.searchItems).subscribe(
        resp => {
          this.serviceProvidersService.updateServiceProviders(resp, this.searchItems, this.searchResults.queryReturnData);
        }
      );
    }
  }

  ngOnDestroy() {
    // this.userSignInSubscription$.unsubscribe();
  }

  onScheduleCall(){

  }

  getSelectedAnalysts(analystId) {
    const index = this.searchResults.findIndex(x => x.id == analystId);
    if (index > -1) {
      this.searchResults[index].isSelected = true;
      this.selectedAnalystList.push(this.searchResults[index])
    }
  }

  removeUnselectedAnalysts(analystId) {
    const index = this.searchResults.findIndex(x => x.id == analystId);
    if (index > -1) {
      this.searchResults[index].isSelected = false;
      this.selectedAnalystList.splice(this.selectedAnalystList.findIndex(x => x.id == analystId), 1);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/analyst-search/analyst-search-results/analyst-search-results.component.ts